import { Router } from '@angular/router';
import { Component } from '@angular/core';

/**
 * Punto di entrata dell'applicazione. Il suo scopo è solamente
 * iniettare/caricare gli altri componenti e, nel caso si perda
 * il login (scaduto/on logout) reindirizza l'utente ad una 
 * pagina di login.
 * 
 * @export
 * @class AppComponent
 */
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	constructor(
		router: Router
	) {
		
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts